import { ELegalIdType, ERegion } from '@constants';
import { IUser } from '@sdk/contracts';
import { isValidPortugueseCC, validateSpanishDocument } from '@utils';
import { FormInstance, Rule } from 'antd/es/form';
import { useTranslation } from 'react-i18next';

interface UseLegalIdValidationParams {
  form: FormInstance<IUser>;
  region?: ERegion;
}

export const useLegalIdValidation = ({
  form,
  region
}: UseLegalIdValidationParams): { legalIdRule: Rule } => {
  const { t } = useTranslation('DefaultTranslations');

  const legalIdRule: Rule = {
    validator: (_, value: string) => {
      if (!value) return Promise.resolve();

      const legalIdType = form.getFieldValue('legalIdType');
      if (legalIdType === ELegalIdType.PASSPORT_OTHER) return Promise.resolve();

      if (region === ERegion.PT) {
        return isValidPortugueseCC(value)
          ? Promise.resolve()
          : Promise.reject(new Error(t('INVALID_PORTUGUESE_CC')));
      }

      const result = validateSpanishDocument(value);
      return result.isValid
        ? Promise.resolve()
        : Promise.reject(new Error(t('INVALID_DNI_NIF_NIE')));
    }
  };

  return { legalIdRule };
};
